import { Chip, chipClasses, styled } from "@mui/material";

export const Badge = styled(Chip)(({ theme }) => ({
  background: theme.palette.background.paper,
  borderWidth: "0.75px",
  height: "auto",
  [`& .${chipClasses.label}`]: {
    ...theme.typography.caption,
    color: "text.primary",
    fontWeight: theme.typography.fontWeightMedium,
    lineHeight: 1.5,
    padding: theme.spacing(0.25, 1),
  },
}));
